<div class="generalPage" aria-label="help-archive content" role="main">
  <div class="pr-22 content-container pb-0 print-all-content" [ngClass]="IsRightPanel?'pt-0':''">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont" role="heading">{{archive_header}}</h1>
    <p class="answer font-16 content-blue width-100 pb-heading" [innerHTML]="archive_body"></p>
    <img alt="Help_archive" class="mb-1-5 width-60" [src]="imageURL" />
    <p class="answer font-24 content-blue width-100 mb-invert-12 bold pb-heading" role="heading">{{archive_para1header}}</p>
    <p class="answer font-16 content-blue width-100" [innerHTML]="archive_para1body"></p>
  </div>
</div>
